import React from "react";
import TopFooter from "./TopFooter";
import BottomFooter from "./BottomFooter";

const FooterSection = () => {
  return (
    <div className="bg-White">
      <TopFooter />
      <BottomFooter />
    </div>
  );
};

export default FooterSection;
